import { loadable } from '@change-corgi/core-react/loadable';

import type { AppRoute } from '#src/shared/routes';

import { Loading } from '#src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'admin-fcm-stats',
		path: '/admin/fcm-stats',
		component: loadable(async () => import(/* webpackChunkName: "pages/admin-fcm-stats" */ './index'), {
			exportName: 'AdminFcmStats',
			fallback: Loading,
		}),
		frame: true,
		restrictedAccess: {
			authOnly: true,
			role: 'staff',
		},
		ssr: {
			enabled: false,
			seo: false,
		},
	},
];
